import { ReactElement } from 'react';
// eslint-disable-next-line max-len
import { FileUploadStatusPropTypes } from '../../types/propTypes/FileUploadStatusPropTypes';
import './FileUploadStatus.css';

const FileUploadStatus = ({
  name,
  percent = 0,
  isCompleted = false,
  isFailed = false,
  error,
  fileType,
}: FileUploadStatusPropTypes): ReactElement => {
  let status;
  let statusText;
  const completedMessage =
    'Your file has been uploaded successfully and the document list has been updated.';
  if (isCompleted) {
    status = 'completed';
    statusText = 'Completed';
  } else if (isFailed) {
    status = 'failed';
    statusText = 'Failed';
  } else if (percent < 0.9) {
    statusText = `${Math.round(percent * 100)}%`;
  } else {
    status = 'awaiting';
    statusText = 'Awaiting Response';
  }

  return (
    <div
      className={`file-upload-status ${
        status ? `file-upload-status--${status}` : ''
      }`}
    >
      <div className="file-upload-status--name-and-status">
        <div className="file-upload-status--name">{name || fileType}</div>
        <div className="file-upload-status--status">{statusText}</div>
      </div>

      <progress value={`${percent}`} />
      {isFailed && error && (
        <div className="file-upload-status--error">{error}</div>
      )}
      {status && status === 'completed' && (
        <div className="file-upload-status--completed-message">
          {completedMessage}
        </div>
      )}
    </div>
  );
};

export default FileUploadStatus;
